/*
 * @Author: YuanYuan
 * @Date: 2024-05-28 18:19:09
 * @LastEditTime: 2025-05-15 11:57:06
 * @Description: 非网站接入常量定义
 */
import i18n from '@/i18n'

export default [
  {
    name: 'ProtocolTypeOptions',
    value: [
      { label: 'TCP', value: '1' },
      { label: 'UDP', value: '2' }
    ]
  },
  {
    name: 'OriginModeOptions',
    value: [
      { label: i18n.t('l4Proxy.polling'), value: '1' }, // 轮询
      { label: i18n.t('l4Proxy.fast'), value: '2' }, // 快速
      { label: i18n.t('l4Proxy.hash'), value: '3' } // 哈希
    ]
  },
  {
    name: 'DeployStatusOptions',
    value: [
      { label: i18n.t('common.deploySuccess'), value: 1, colorClazz: 'text-color-success' }, // 部署成功
      { label: i18n.t('common.deploying'), value: 2, colorClazz: 'text-color-gold' } // 部署中
    ]
  },
  {
    name: 'PortTypeOptions',
    value: [
      { label: i18n.t('common.port'), value: 1 }, // 端口
      { label: i18n.t('common.portRange'), value: 2 } // 端口范围
    ]
  }
]
